<div
  class="omnisearch"
  #host
  [class.is-compact]="isCompact()"
  [class.visible]="isVisible() || hasResults()"
  [class.has-results]="hasResults()"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
>
  <mat-form-field class="omnisearch__field" appearance="fill" subscriptSizing="dynamic" color="accent">
    @if (isCompact()) {
      <button mat-icon-button matPrefix type="button" (click)="closeSearch()" aria-label="Close search">
        <mat-icon>arrow_back</mat-icon>
      </button>
    } @else {
      <button mat-icon-button matPrefix type="button" tabindex="-1" aria-hidden="true">
        <mat-icon>search</mat-icon>
      </button>
    }
    <input
      type="text"
      matInput
      placeholder="Patients Search"
      autocomplete="off"
      [formControl]="formControl"
      xuiSearchBox
      [searchObservable]="searchObservable"
      [minCharacters]="2"
      (results)="onSearchResults($event)"
      (searchError)="onSearchError($event)"
      (searchStatusChange)="onSearchStatusChange($event)"
    />
    @if (formControl.value?.length > 0) {
      <button mat-icon-button matSuffix type="button" aria-label="Clear search" (click)="cancelSearch()">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </mat-form-field>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="resultsReady()"
    [cdkConnectedOverlayHasBackdrop]="false"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPanelClass]="overlayPanelClass()"
  >
    <div class="omnisearch__results mat-elevation-z3">
      @if (hasResults()) {
        @for (group of groupedResults(); track group.key) {
          @if (group.kind === 'cohort') {
            <div class="omnisearch__cohort">
              <div class="omnisearch__cohort-header">
                <mat-icon class="omnisearch__cohort-icon">account_tree</mat-icon>
                <span class="omnisearch__cohort-title">{{ cohortHeader(group) }}</span>
                <span class="omnisearch__cohort-meta">
                  @if (group.members[0].dateOfBirth) {
                    <span>{{ group.members[0].dateOfBirth | date:'mediumDate' }}</span>
                  }
                  @if (group.members[0].identityNumber) {
                    <span>· {{ group.members[0].identityNumber }}</span>
                  }
                  <span>· {{ group.members.length }} practices</span>
                </span>
              </div>
              @for (member of group.members; track member.id) {
                <button type="button" class="omnisearch__row omnisearch__row--cohort-member" (click)="selectResult(member)">
                  @if (member.practiceLogoUrl) {
                    <img class="omnisearch__practice-logo" [src]="member.practiceLogoUrl" alt="" />
                  } @else {
                    <mat-icon class="omnisearch__practice-icon">local_hospital</mat-icon>
                  }
                  <span class="omnisearch__practice-name">{{ member.practiceName || ('Practice #' + member.practiceId) }}</span>
                  <span class="omnisearch__profile-id">#{{ formatProfileId(member) }}</span>
                  <span class="omnisearch__last-modified">updated {{ member.modifiedDateUtc | practiceDateTime:'mediumDate' }}</span>
                </button>
              }
            </div>
          } @else {
            @let row = group.members[0];
            <button type="button" class="omnisearch__row omnisearch__row--singleton" (click)="selectResult(row)">
              <span class="omnisearch__top-line">
                <span class="omnisearch__profile-id">#{{ formatProfileId(row) }}</span>
                <span class="omnisearch__name">{{ row.displayName || row.fullName || row.name }}</span>
                <span class="omnisearch__practice-pill">
                  @if (row.practiceLogoUrl) {
                    <img class="omnisearch__practice-logo" [src]="row.practiceLogoUrl" alt="" />
                  }
                  {{ row.practiceName || ('Practice #' + row.practiceId) }}
                </span>
              </span>
              <span class="omnisearch__meta">
                @if (row.dateOfBirth) {
                  <span>{{ row.dateOfBirth | date:'mediumDate' }}</span>
                }
                @if (row.identityNumber) {
                  <span>· {{ row.identityNumber }}</span>
                }
                @if (row.cell) {
                  <span>· {{ row.cell }}</span>
                }
              </span>
            </button>
          }
        }
      }

      @if (showNoResults()) {
        <div class="omnisearch__row omnisearch__row--center">
          <span class="omnisearch__empty">No patients found. New patients are created via the calendar booking flow.</span>
        </div>
      }
    </div>
  </ng-template>
</div>
